import { UATConstants } from 'src/Common/Models/UATConstants';
import { ITenantUIConfig, TenantProvider } from './interface';
import { SGSFilterConfig } from './filters/SGCIFilterConfig';
export const SGSTenantConfig: Partial<ITenantUIConfig> = {
  nodeName: [UATConstants.PlaceholdersAndTitles.SGSTitle],
  provider: TenantProvider.ARTEMIS,
  TenantExperience: true,
  FeatureConfig: {
    SensitiveInfoValidation: false,
    SensativeInfoErrorCount: false,
    FieldConfig: SGSFilterConfig,
    AttachmentConfigurations: [],
    Navigation: {
      GlobalSearch: true,
      Copilot: true,
      Analytics: false,
      RequestAccess: false,
      Settings: true,
      Notifications: true,
      Help: true,
    },
    Hub: {
      Filter: true,
      FilterConfig: SGSFilterConfig,
      Title: UATConstants.TenantTitles.SGS,
      ADOTitle: UATConstants.TenantADOText.SGS,
      Create: [
        {
          Text: UATConstants.CreateActionMenuTitle.CreateSGSRequest,
          Key: UATConstants.CreateActionMenuKey.CreateSGSRequest,
          NodeName: '',
        },
      ],
      BulkUpload: true,
      DownloadTemplate: true,
      DownloadTemplateConfig: {
        tenantToolName: 'sgs',
        title: UATConstants.SGS,
        excelColumnSequence: {
          'Title': 1,
          'Assigned Team': 2,
          'Action Owner': 3,
          'TPID': 4,
          'Account Owner': 5,
          'Account Name': 6,
          'Time Zone': 7,
          'Field Accountability Unit': 8,
          'Field Subsidiary': 9,
          'Segment': 10,
          'Has Unified Support': 11,
          'Tier': 12,
          'Sub-Tier': 13,
          'Account Cohort': 14,
          'Schiphol Flag': 15,
          'Account Team Briefing Status': 16,
          'Customer Briefing Status': 17,
          'Growth Shaping Steps': 18,
          'Customer Status and Next Steps': 19,
          'Primary Growth Shaping Contact': 20,
          'Growth Lead': 21,
          'AE Contact': 22,
          'ATS Contact': 23,
          'STU Contact': 24,
          'CSAM Contact': 25,
          'CSA Contact': 26,
          'DC Region From 1': 27,
          'Customer Status 1': 28,
          'Growth Shaping ETA 1': 29,
          'Risk/Blocker/Other Details 1': 30,
          'DC Region From 2': 31,
          'Customer Status 2': 32,
          'Growth Shaping ETA 2': 33,
          'Risk/Blocker/Other Details 2': 34,
          'DC Region From 3': 35,
          'Customer Status 3': 36,
          'Growth Shaping ETA 3': 37,
          'Risk/Blocker/Other Details 3': 38,
          'DC Region From 4': 39,
          'Customer Status 4': 40,
          'Growth Shaping ETA 4': 41,
          'Risk/Blocker/Other Details 4': 42,
          'DC Region From 5': 43,
          'Customer Status 5': 44,
          'Growth Shaping ETA 5': 45,
          'Risk/Blocker/Other Details 5': 46,
          'DC Region From 6': 47,
          'Customer Status 6': 48,
          'Growth Shaping ETA 6': 49,
          'Risk/Blocker/Other Details 6': 50,
          'DC Region From 7': 51,
          'Customer Status 7': 52,
          'Growth Shaping ETA 7': 53,
          'Risk/Blocker/Other Details 7': 54,
          'DC Region From 8': 55,
          'Customer Status 8': 56,
          'Growth Shaping ETA 8': 57,
          'Risk/Blocker/Other Details 8': 58,
          'DC Region From 9': 59,
          'Customer Status 9': 60,
          'Growth Shaping ETA 9': 61,
          'Risk/Blocker/Other Details 9': 62,
          'State': 63,
          'Status Update': 64,
        },
      },
      Download: true,
      Email: true,
      LocalSearch: true,
      ColumnOptions: false,
      ColumnOptionsConfig: [],
      SplitMode: true,
      BulkEdit: false,
      BulkEditConfig: [],
      CreateRAID: false,
      DropdownValues: {
        [UATConstants.ArtemisFieldPaths.State]: [
          UATConstants.ArtemisStateDropdownValues.OnTrack,
          UATConstants.ArtemisStateDropdownValues.AtRiskOrBlocked,
          UATConstants.ArtemisStateDropdownValues.Completed,
          UATConstants.ArtemisStateDropdownValues.NotStarted,
        ],
      },
    },
    ManageAction: {
      Header: {
        Tags: true,
        Actions: {
          Follow: true,
          Email: true,
          CopyLink: true,
        },
      },
      Tabs: {
        TechnicalFeedback: false,
        RelatedItems: {
          showRelatedTab: true,
          showTFTCreated: false,
        },
        Attachments: true,
        History: true,
      },
      Panes: {
        CopilotInsights: {
          CustomerInsights: false,
          DiscussionInsights: false,
        },
        StatusUpdate: true,
        ClosureStatement: true,
        Discussion: true,
        Tasks: false,
        EmailConversation: false,
      },
      NewExperience: true,
      MandateFormPickers: [
        { formFieldName: 'assignedto', formFieldLabel: UATConstants.PlaceholdersAndTitles.ActionOwner, apiFieldName: 'assignedto' },
        { formFieldName: 'SGS_AccountOwner', formFieldLabel: UATConstants.PlaceholdersAndTitles.AccountOwner, apiFieldName: 'SGS_AccountOwner' },
        {
          formFieldName: 'SGS_PrimaryGrowthShapingContact',
          formFieldLabel: UATConstants.PlaceholdersAndTitles.PrimaryGrowthShapingContact,
          apiFieldName: 'SGS_PrimaryGrowthShapingContact',
        },
        { formFieldName: 'SGS_GrowthLead', formFieldLabel: UATConstants.PlaceholdersAndTitles.GrowthLead, apiFieldName: 'SGS_GrowthLead' },
        { formFieldName: 'SGS_AEContact', formFieldLabel: UATConstants.PlaceholdersAndTitles.AEContact, apiFieldName: 'SGS_AEContact' },
        { formFieldName: 'SGS_ATSContact', formFieldLabel: UATConstants.PlaceholdersAndTitles.ATSContact, apiFieldName: 'SGS_ATSContact' },
        { formFieldName: 'SGS_STUContact', formFieldLabel: UATConstants.PlaceholdersAndTitles.STUContact, apiFieldName: 'SGS_STUContact' },
        { formFieldName: 'SGS_CSAMContact', formFieldLabel: UATConstants.PlaceholdersAndTitles.CSAMContact, apiFieldName: 'SGS_CSAMContact' },
        { formFieldName: 'SGS_CSAContact', formFieldLabel: UATConstants.PlaceholdersAndTitles.CSAContact, apiFieldName: 'SGS_CSAContact' },
        { formFieldName: 'SGS_TechEnablementSTU', formFieldLabel: UATConstants.PlaceholdersAndTitles.TechEnablementSTU, apiFieldName: 'SGS_TechEnablementSTU' },
        { formFieldName: 'SGS_ExecSponsor', formFieldLabel: UATConstants.PlaceholdersAndTitles.ExecSponsor, apiFieldName: 'SGS_ExecSponsor' , allowedList: ['sgs_exec_sponsor_alias']},
        { formFieldName: 'SGS_TechEnablementSTU', formFieldLabel: UATConstants.PlaceholdersAndTitles.TechEnablementSTU, apiFieldName: 'SGS_TechEnablementSTU' , allowedList: ['sgs_techenablement_stu']},
        { formFieldName: 'SGS_WWCSUEngaged', formFieldLabel: UATConstants.PlaceholdersAndTitles.WWCSUEngaged, apiFieldName: 'SGS_WWCSUEngaged' , allowedList: ['sgs_wwcsu_engaged']},
        { formFieldName: 'SGS_SubOUGrowthLead', formFieldLabel: UATConstants.PlaceholdersAndTitles.SubGrowthLead, apiFieldName: 'SGS_SubOUGrowthLead' , allowedList: ['sgs_sub_ou_growth_lead']},
        { formFieldName: 'SGS_RegionalGrowthLead', formFieldLabel: UATConstants.PlaceholdersAndTitles.RegionalGrowthLead, apiFieldName: 'SGS_RegionalGrowthLead' , allowedList: ['sgs_regional_growth_lead']},
      ],
    },
    ManageView: {
      showAddViewButton: true,
      showAddFolderButton: true,
      isArtemisIntegrationEnabled: true,
      showCommandBar: true,
      showPreviewFeatureMessageBar: false,
      showSelectFields: false,
      defaultViewId: '97b740c2-185e-4867-9769-0ea8d0e2973e',
      systemViewsFolderId: '801770de-28bf-4fa1-88c7-17edca484e60',
      sharedViewsFolderId: 'dee15330-c3f8-417d-9e98-2cc0ccc138d5',
      dropdownValues: {
        [UATConstants.ArtemisFieldPaths.State]: [
          UATConstants.ArtemisStateDropdownValues.OnTrack,
          UATConstants.ArtemisStateDropdownValues.AtRiskOrBlocked,
          UATConstants.ArtemisStateDropdownValues.Completed,
          UATConstants.ArtemisStateDropdownValues.NotStarted,
        ],
      },
    },
  },
};
